import { lockScroll, unlockScroll } from './scrollBlocker';

export default function mobileCallback() {
    const burgerMenuOpenBtns = Array.from(document.querySelectorAll('.js-mobile-callback-open'));
    const burgerMenu = document.querySelector('.js-mobile-callback');
    const burgerMenuCloseBtn = document.querySelector('.js-mobile-callback-close');

    let burgerMenuOpen = false;

    if (burgerMenu && burgerMenuCloseBtn) {
        const handleMenu = () => {
            if (!burgerMenuOpen) {
                lockScroll(burgerMenu);
                document.body.classList.add('mobile-callback-shown');
                burgerMenuOpen = true;
            } else {
                unlockScroll();
                document.body.classList.remove('mobile-callback-shown');
                burgerMenuOpen = false;
            }
        };


        burgerMenuOpenBtns.forEach(btn => {
            btn.addEventListener('click', event => {
                event.preventDefault();
                handleMenu();
            });
        })
        

        burgerMenuCloseBtn.addEventListener('click', event => {
            event.preventDefault();
            handleMenu();
        });

        document.addEventListener('click', event => {
            const insideMenu = event.target.matches('.js-mobile-callback') || event.target.closest('.js-mobile-callback');
            const insideOpenButton = event.target.matches('.js-mobile-callback-open') || event.target.closest('.js-mobile-callback-open');
            if (!insideMenu && !insideOpenButton) {
                if (burgerMenuOpen) {
                    unlockScroll();
                    document.body.classList.remove('mobile-callback-shown');
                    burgerMenuOpen = false;
                }
            }
        });
    } else {
        console.log('Not enough elements')
    }
}
